import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { FormattedMessage } from "react-intl";
import { components } from "react-select";
import { ThemeContext } from "styled-components";
import { Label } from "../Label";
import { Select } from "../Select";
import { useHandlerWhenClickedOutside } from "../../../hooks";
import { Icon } from "../Icon";
import * as S from "./styles";
export var DropdownSelect = function DropdownSelect(_ref) {
  var options = _ref.options,
      name = _ref.name,
      value = _ref.value,
      _onChange = _ref.onChange;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      menuIsOpen = _React$useState2[0],
      setMenuIsOpen = _React$useState2[1];

  var _useHandlerWhenClicke = useHandlerWhenClickedOutside(function () {
    setMenuIsOpen(false);
  }),
      setElementRef = _useHandlerWhenClicke.setElementRef;

  var customComponents = {
    Control: function Control() {
      return React.createElement(S.SortLine, {
        onClick: function onClick() {
          return setMenuIsOpen(!menuIsOpen);
        }
      }, React.createElement(Label, null, React.createElement(FormattedMessage, {
        id: "@next.components.atoms.DropdownSelect.DropdownSelect.3280510613",
        defaultMessage: "Sort by:"
      }), " "), React.createElement(S.Value, null, " ".concat(value ? value.label : "")), React.createElement(S.Indicator, {
        rotate: String(menuIsOpen)
      }, React.createElement(Icon, {
        name: "select_arrow",
        size: 10
      })));
    },
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    },
    IndicatorsContainer: function IndicatorsContainer() {
      return null;
    },
    Option: function Option(props) {
      var customTheme = React.useContext(ThemeContext);
      return React.createElement(components.Option, _objectSpread({
        customTheme: customTheme
      }, props));
    }
  };
  return React.createElement(S.Wrapper, {
    "data-test": "sortingDropdown",
    ref: setElementRef()
  }, React.createElement(Select, {
    options: options,
    value: value,
    onChange: function onChange(value) {
      setMenuIsOpen(false);

      _onChange(value);
    },
    name: name,
    menuIsOpen: menuIsOpen,
    customComponents: customComponents
  }));
};